import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

let count = 0;

export const getUniqueId = () => {
  return `unique-${count++}`;
};
